import * as React from "react";
import { connect } from "react-redux";
import { State } from "../../../state";
import { formatMoneyValue } from "../../../utils/formatters";
import { getUnmappedAccounts } from "../../model/spread/selector";
import { SpreadUnmappedAccount } from "../../model/spread/types";
import closeIcon from "./close.svg";
import "./UnmappedAccountsPanel.scss";

interface UnmappedAccountsPanelProps {
  unmappedAccounts: SpreadUnmappedAccount[];
  closePanel: () => void;
}

export class UnmappedAccountsPanel extends React.Component<
  UnmappedAccountsPanelProps
> {
  public render() {
    const { unmappedAccounts } = this.props;

    return (
      <div className="UnmappedAccountsPanel">
        <div className="UnmappedAccountsPanel__header">
          <div className="UnmappedAccountsPanel__count">
            {unmappedAccounts.length}
          </div>
          <div className="UnmappedAccountsPanel__title">unmapped</div>
          <div
            className="UnmappedAccountsPanel__icon-container"
            onClick={this.props.closePanel}
          >
            <img
              className="UnmappedAccountsPanel__close-icon"
              src={closeIcon}
            />
          </div>
        </div>
        <div className="UnmappedAccountsPanel__content">
          <div className="UnmappedAccountsPanel__account-list-header">
            Unmapped from statement:
          </div>
          <div className="UnmappedAccountsPanel__account-list">
            {unmappedAccounts.map(account => (
              <div
                key={account.id}
                className="UnmappedAccountsPanel__account-list-item"
              >
                <div className="UnmappedAccountsPanel__list-item-text">
                  {account.labelCell.adjustedOcrText}
                </div>
                <div className="UnmappedAccountsPanel__list-item-value">
                  {formatMoneyValue(parseInt(account.valueCell.value, 10))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  unmappedAccounts: getUnmappedAccounts(state)
});

export default connect(mapStateToProps)(UnmappedAccountsPanel);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/unmappedAccounts/UnmappedAccountsPanel.tsx